import appConfig from '@nerdwallet/app-config';

export default {
  preheader: 'Meet your new match',
  header: 'Find your best credit cards',
  subtitle:
    'Quickly see which cards offer the lowest rate, most cash back or sweetest perks.',
  subtitleMobile:
    'Quickly see which cards offer the lowest rate, most cash back or sweetest perks.',
  buttonText: 'Find cards',
  backgroundImage: `${appConfig.ASSETS_URL}/images/homepage/cc-tool-image.svg`,
  backgroundClassname: 'cc-tool-image',
};
